import React from 'react';
import { Link } from 'react-router-dom';
import csomagszallitasImg from '../img/csomagszallitas.png';
import '../App.css';

const QUOTE_CSOMAG_PATH = '/ajanlat/csomagszallitas';

const QUOTE_ITEMS = [
  'felvételi és cél cím (város, irányítószám, ország)',
  'a küldemény pontos mérete és súlya',
  'normál kézbesítés vagy in-home szolgáltatás igénye',
  'törékeny, értékes vagy speciális tétel megjelölése',
  'biztosítás és becsült érték (ha szükséges)',
];

/** Méret / súly – keret, nyílak */
function IconDimensions() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="14" y="18" width="36" height="30" rx="1" stroke="currentColor" strokeWidth="2" />
      <path
        d="M22 14l-5-5M42 14l5-5M22 50l-5 5M42 50l5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M32 26v12M26 32h12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M28 40c2 4 4 6 4 6s2-2 4-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Üzlet / első ajtóig */
function IconStorefront() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M12 28l20-10 20 10v30H12V28z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M10 28h44" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M18 28c0-4 3-8 8-8h12c5 0 8 4 8 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M26 48V34h12v14" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

/** Otthon + védelem / biztosítás */
function IconHouseCare() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M32 14L48 26v22H16V26l16-12z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M24 48V34h16v14" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M8 52c4-8 12-12 24-12s20 4 24 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 54c4-6 10-9 20-9s16 3 20 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Ajándék / címkézés */
function IconGiftLabeled() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="16" y="24" width="32" height="28" rx="1" stroke="currentColor" strokeWidth="2" />
      <path d="M32 24V52M16 36h32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M26 24c0-4 3-6 6-6s6 2 6 6M32 18v6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 14h20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

/** Csomagolás szolgáltatás */
function IconWePack() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="14" y="22" width="36" height="30" rx="1" stroke="currentColor" strokeWidth="2" />
      <path d="M32 22v30M14 34h36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="32" cy="34" r="3" stroke="currentColor" strokeWidth="2" />
      <path
        d="M26 16l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function CsomagszallitasPage() {
  return (
    <main className="svc-page">
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <nav className="svc-breadcrumb-trail" aria-label="Útvonal">
            <Link className="svc-breadcrumb-seg" to="/" state={{ scrollTo: 'szolgaltatas' }}>
              Szolgáltatások
            </Link>
            <span className="svc-breadcrumb-sep" aria-hidden="true">
              /
            </span>
            <span className="svc-breadcrumb-current" aria-current="page">
              Csomagszállítás
            </span>
          </nav>

          <div className="svc-hero-grid">
            <div className="svc-hero-text">
              <h1>Szeretnél csomagot feladni?</h1>
              <p>
                Legyen szó hétköznapi csomagról, speciális méretű küldeményről, képről, festményről,
                szoborról, hangszerről, trófeáról vagy sporteszköz szállításáról, mi vállaljuk.
              </p>
              <Link className="primary-btn svc-hero-cta" to={QUOTE_CSOMAG_PATH}>
                Ajánlatot kérek
              </Link>
            </div>

            <div className="svc-hero-media">
              <img src={csomagszallitasImg} alt="Csomagszállítás – csomagok és küldemények" />
            </div>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--cream svc-icon-rows-wrap" aria-label="Hasznos információk">
        <div className="svc-band-inner svc-icon-rows-inner">
          <p className="svc-cream-intro">
            Szeretnénk számodra a lehető legjobb szolgáltatást nyújtani, ezért jó, ha néhány hasznos
            információt elolvasol:
          </p>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconDimensions />
            </div>
            <p className="svc-icon-row-text">
              Fontos, hogy a szállítandó terméked <strong>méretét és súlyát</strong> a lehető
              legpontosabban add meg. Az ajánlatkérésben ezt meg tudod tenni.
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconStorefront />
            </div>
            <p className="svc-icon-row-text">
              A normál szállítást <strong>első zárt ajtóig/kapuig</strong> vállaljuk. Van lehetőség az
              „In-home szolgáltatásra”, ahol a sofőr segít a rakodásban, a lakásba vagy akár az emeletre
              való bevitelben. Kérlek vedd figyelembe, hogy a sofőr egyedül közlekedik, ezért nagyobb,
              terjedelmes termékek esetén szükség van neki segítségre.
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconHouseCare />
            </div>
            <p className="svc-icon-row-text">
              Ajánlunk a szállításhoz <strong>kedvező biztosítási konstrukciót</strong>.
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconGiftLabeled />
            </div>
            <p className="svc-icon-row-text">
              <strong>Csomagolás:</strong> Mindig figyelj oda a biztonságos csomagolásra. Érdemes a
              csomagot megcímkézni (feladó és címzett neve és telefonszáma, rendelésszám). Törékeny
              csomag esetén legyen a csomagra ráírva jól látható helyen.
            </p>
          </div>

          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconWePack />
            </div>
            <p className="svc-icon-row-text">
              Igény esetén <strong>csomagoljuk is a termékeket</strong>.
            </p>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--quote" aria-labelledby="csomag-quote-h">
        <div className="svc-band-inner svc-quote-layout">
          <div className="svc-quote-main">
            <h2 id="csomag-quote-h">Mi alapján készül az ajánlat?</h2>
            <p className="svc-quote-lead">A pontos ajánlathoz kérjük add meg:</p>
            <ul className="svc-bullet-list svc-bullet-list--quote">
              {QUOTE_ITEMS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <p className="svc-tip svc-tip--in-card">
              Ha tudsz, csatolj képet vagy dokumentumot a küldeményről – így gyorsabban és pontosabban
              tudunk ajánlatot adni.
            </p>
          </div>

          <aside className="svc-quote-aside" aria-labelledby="csomag-quote-info-h">
            <h2 id="csomag-quote-info-h" className="svc-quote-aside-title">
              Információk:
            </h2>
            <ul className="svc-quote-info-list">
              <li>
                Kérünk, hogy a pontos árajánlathoz <strong>minden mezőt tölts ki</strong> a valóságnak
                megfelelően!
              </li>
              <li>
                A <strong>csillaggal jelölt mezők</strong> kitöltése kötelező.
              </li>
              <li>
                Áraink <strong>nettó árak</strong>. Az Áfát nem tartalmazzák!
              </li>
              <li>
                Az árajánlat elküldését követően <strong>1–5 napon belül</strong> tudjuk a pontos
                árajánlatot kiküldeni.
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section className="svc-band svc-band--dark">
        <div className="svc-band-inner svc-closing">
          <h2>Fontos küldeményed van?</h2>
          <p>Küldd el az adatokat, és készítünk egy személyre szabott ajánlatot.</p>
          <Link className="primary-btn svc-closing-btn" to={QUOTE_CSOMAG_PATH}>
            Ajánlatot kérek
          </Link>
        </div>
      </section>

      <section className="svc-band svc-band--white svc-gyik-band">
        <div className="svc-band-inner svc-gyik-row">
          <p className="svc-gyik-text">
            Ha valami kérdésed maradt még, email vagy telefon előtt keresd a GYIK-ben.
            <br />
            Biztos rátalálsz a válaszra.
          </p>
          <Link className="svc-gyik-link" to="/gyik">
            Tovább a GYIK-hez →
          </Link>
        </div>
      </section>
    </main>
  );
}
